<img [src]="reportImage.ImagePath" [alt]="reportImage.Name" class="img-responsive">
